import { DateTime } from 'luxon'

export function isPastUtcDate(targetDate: Date): boolean {
  const currentDate = DateTime.fromJSDate(new Date()).toUTC().toJSDate()
  return currentDate > targetDate
}
